import { Uuid } from "@/domains/global/identifiers";
import { Flex } from "@radix-ui/themes";
import { BaseButton } from "@/components/button";
import { FC } from "react";

interface UuidRowProps {
  id?: Uuid | null;
  truncate?: boolean;
}

const ID_LENGTH_TRUNCATION = 11;
// => 5540e01c-ced5-5f95-ab08-6fc8c24cd1d0
// => 5540e01c-ce...

export const UuidFieldRow: FC<UuidRowProps> = ({ id, truncate = true }) => {
  const handleClick = () => {
    if (!id) {
      return;
    }

    navigator.clipboard.writeText(id);
  };

  if (!id) {
    return <div />;
  }

  const truncatedId =
    id.length > ID_LENGTH_TRUNCATION && truncate ? `${id.substring(0, ID_LENGTH_TRUNCATION)}…` : id;

  return (
    <Flex align="center" justify="start" pl="1" pr="1">
      <BaseButton variant="outline" size="1" onClick={handleClick}>
        {truncatedId}
      </BaseButton>
    </Flex>
  );
};
